import { configureStore } from "@reduxjs/toolkit";
import keyarDataReducer from "./features/central_monitor/keyarData";
import liveKeyarDataReducer from "./features/central_monitor/liveKeyarData";
import basicDetailReducer from './features/central_monitor/basic_detail'
import liveOneSecKeyarDataReducer from './features/central_monitor/liveOneSecKeyarData'
import {createStateSyncMiddleware, initMessageListener} from "redux-state-sync";
import configurationReducer from './features/login/appConfiguration'
import placeDetailReducer from "./features/login/placeDetail";
import patientDetailReducer from "./features/details/patientDetail";


export const store = configureStore({
    reducer: {
        keyarData: keyarDataReducer,
        liveKeyarData: liveKeyarDataReducer,
        liveBasicDetail: basicDetailReducer,
        liveOneSecKeyarData: liveOneSecKeyarDataReducer,
    },
    middleware: (getDefaultMiddleware) =>
        // The live-vitals slice receives ~1 batch/s with thousands of keys per
        // param; RTK's dev-only immutable/serializable checks walk the whole
        // state on every action and flag its non-plain series container.
        getDefaultMiddleware({ immutableCheck: false, serializableCheck: false }).concat(
            // Every tab owns its WebSocket, so live frames must not be
            // re-broadcast to (and re-reduced by) every other open tab.
            createStateSyncMiddleware({
                blacklist: [
                    "liveKeyarData/mergeLiveKeyarSample",
                    "liveKeyarData/mergeLiveKeyarSamples",
                    "liveKeyarData/pruneStaleLiveSessions",
                ],
            })
        )
})

initMessageListener(store);

